export default __webpack_public_path__ + "static/media/september.daf3a52c.jpeg";